/* eslint-disable import/prefer-default-export */
enum inputValues {
    default,
    subscription
}

export { inputValues };
